import { useState, useEffect, useCallback } from 'react';

export const useAlerts = () => {
  const [permission, setPermission] = useState('default');

  useEffect(() => {
    if ('Notification' in window) {
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = async () => {
    if (!('Notification' in window)) {
      alert('This browser does not support desktop notification');
      return false;
    }
    const result = await Notification.requestPermission();
    setPermission(result);
    return result === 'granted';
  };

  const triggerAlert = useCallback((title, options = {}) => {
    if (permission === 'granted') {
      new Notification(title, {
        icon: 'https://media-manager-c.questera.ai/greta-media/88577bf33df42fc0146f97d319dec09e53e853cea0703950ad5359a5e5d96838b999b0f46937cf1ca2813cf9b0cbaa03/images/aW1hZ2UvcG5n/2310aeb4984f4005e562c0177ff4d546.png',
        ...options,
      });
    } else if (permission !== 'denied') {
      requestPermission().then((granted) => {
        if (granted) {
          new Notification(title, {
            icon: 'https://media-manager-c.questera.ai/greta-media/88577bf33df42fc0146f97d319dec09e53e853cea0703950ad5359a5e5d96838b999b0f46937cf1ca2813cf9b0cbaa03/images/aW1hZ2UvcG5n/2310aeb4984f4005e562c0177ff4d546.png',
            ...options,
          });
        }
      });
    }
  }, [permission]);

  return { permission, requestPermission, triggerAlert };
};